import styled, { css } from "styled-components";
import { Paragraph2, WrapperContainer } from "../../../../components";
import { colors, darkModeColors } from "../../../../consts";

const SelectedStyles = css`
  border-color: ${darkModeColors.RAISIN_100_RAISIN_40};

  background: ${(props) => (props?.theme?.darkMode ? colors.RAISIN_100 : "rgba(52, 48, 61, 0.1)")};

  ${Paragraph2} {
    font-weight: 500;
  }
`;

export const LanguageItemWrapper = styled(WrapperContainer)`
  border-radius: 8px;
  border: 1px solid;

  border-color: ${darkModeColors.RAISIN_100_IRON};

  ${(props) => props?.isSelected && SelectedStyles}

  cursor: pointer;

  &:hover {
    ${SelectedStyles}
  }
`;
